// The API is reached through this same CloudFront distribution's "/api/*"
// proxy path (see Galaxy-serverless/lib/stacks/gateway-stack.ts) — any
// request to this frontend domain with an "/api" sub-route is routed to the
// backend API by CloudFront, so it's never a separate API domain per tenant.
// One build is served under multiple tenant aliases (e.g. demo-serverless /
// acme-serverless), so this can't be a single absolute value baked in at
// build time. VUE_APP_API_HOST still wins when set, for local dev (no
// CloudFront proxy running on localhost). Mirrors builderUI/src/constants.js.
function deriveApiHost() {
  if (process.env.VUE_APP_API_HOST) return process.env.VUE_APP_API_HOST;
  if (typeof window === "undefined") return "";
  return `${window.location.origin}/api`;
}

export const apiHost = deriveApiHost();
